export enum ProjectChecklistItemStatus {
  Completed,
  InProgress,
  ToDo,
  NA
}
